import { useState } from 'react';
import { useRouter } from 'next/router';
import { Button } from '@mui/material';
// Components
import { PageHeader } from '@/components/common';
import NodeBanner from './NodeBanner';
// Hooks
import { useIsMobile } from '@/hooks/useIsMobile';
import { useWebiny } from '@/providers/WebinyProvider';
// Styles & Assets
import styles from '../DashboardNodes/dashboard-nodes.module.css';
import { WalletIcon } from '@/assets/icons/iconComponents/sideNav';
import { NodesIcon } from '@/icons/iconComponents/sideNav';

export default function NodePageHeader({
  isWalletSetup,
  isWalletLoading,
  memberRewards,
  handleSetNavBadges,
}) {
  const isMobile = useIsMobile(650);
  const router = useRouter();
  const { pageHeader } = useWebiny();
  const { primaryButton, secondaryButton } = pageHeader;

  const [showBanner, setShowBanner] = useState(
    memberRewards.signupNodeReward || memberRewards.referralNodeReward
  );

  const handleRoute = () =>
    isWalletSetup ? router.push(primaryButton.url) : router.push(secondaryButton.url);

  const handleCloseBanner = () => {
    handleSetNavBadges({ id: 'nodes', value: false });
    setShowBanner(false);
  };

  return (
    <>
      <PageHeader data-core-qa="walletVaultTitleText" headerText={pageHeader.title}>
        {isWalletLoading ? null : (
          <Button
            sx={{ marginBottom: '16px', marginTop: '16px' }}
            variant="contained"
            fullWidth={isMobile}
            onClick={handleRoute}
            data-core-qa="headerButton"
          >
            {isWalletSetup ? (
              <>
                <NodesIcon className={styles.brandIcon} />
                {primaryButton.title}
              </>
            ) : (
              <>
                <WalletIcon className={styles.brandIcon} />
                {secondaryButton.title}
              </>
            )}
          </Button>
        )}
      </PageHeader>
      {showBanner && <NodeBanner handleCloseBanner={handleCloseBanner} />}
    </>
  );
}
